var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attendance-nav-panel"},[(_vm.title)?_c('div',{staticClass:"title"},[_c('h1',[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_c('hr')]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }